import { render, staticRenderFns } from "./DashPlatformSetup.vue?vue&type=template&id=3450e050"
import script from "./DashPlatformSetup.vue?vue&type=script&lang=js"
export * from "./DashPlatformSetup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports